<template>
  <div class="scene-model">

  </div>
</template>

<script>
  export default {
    components: {},
    name: 'scene-model'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SceneModel/SceneModel.vue